module.exports = __webpack_public_path__ + "static/img/generaltopic_banner.bcec650.png";


//////////////////
// WEBPACK FOOTER
// ./src/appBackend/assets/example/generaltopic_banner.png
// module id = 1107
// module chunks = 2